import type { CourseModule } from "@/core/types";
import { lektionZielwertsuche } from "./lektion-01-zielwertsuche";
import { lektionSzenarien } from "./lektion-02-szenarien";
import { lektionDatentabelle } from "./lektion-03-datentabelle";
import { lektionSolver } from "./lektion-04-solver";

/**
 * Die Was-wäre-wenn-Werkzeuge der Registerkarte „Daten“.
 *
 * Zielwertsuche und Datentabelle werden am Ergebnis erkannt, der Solver über
 * die versteckten Namen, in denen Excel sein Modell speichert. Szenarien
 * kennt nur VBA.
 */
export const modulWasWaereWenn: CourseModule = {
  id: "was-waere-wenn",
  title: "Was-wäre-wenn-Analysen",
  summary:
    "Zielwertsuche, Szenario-Manager, Datentabelle, Prognoseblatt und Solver – " +
    "Rechenmodelle befragen, statt Zahlen auszuprobieren.",
  level: "Aufbau",
  lessons: [lektionZielwertsuche, lektionSzenarien, lektionDatentabelle, lektionSolver],
};
